import appIllustration from '@/views/illustration.vue'
import { createRouter, createWebHistory } from 'vue-router'
import appAbout from '../views/about.vue'
import appContact from '../views/contact.vue'
import appHome from '../views/home.vue'
import appIdTags from '../views/idtags'
import myPet from '../views/mypet.vue'
import appPolicy from '../views/policy.vue'
import appProduct from '../views/product.vue'
import Showpet from '../views/showpet.vue'
import appSupport from '../views/support.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: appHome,
    meta: {
      showFooter: false
    }
  },
  {
    path: '/about',
    name: 'about',
    component: appAbout,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/product',
    name: 'product',
    component: appProduct,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/support',
    name: 'support',
    component: appSupport,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: appContact,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/idtags',
    name: 'idtags',
    component: appIdTags,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/policy',
    name: 'policy',
    component: appPolicy,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/illustration',
    name: 'illustration',
    component: appIllustration,
    meta: {
      showFooter: true
    }
  },
  {
    path: '/mypet',
    name: 'mypet',
    component: myPet,
    meta: {
      showFooter: false
    }
  },
  {
    path: '/showpet',
    name: 'showpet',
    component: Showpet,
    meta: {
      showFooter: false
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
